import PropTypes from "prop-types";

import { strCode } from "../../../../consts";
import { t } from "../../../../services";
import { csvUtil } from "../../../../utils";
import { reportUtils } from "../../utils/reportUtils";

import {
  ChartLabelsInfoTooltip,
  FlexContainers,
  IconButton,
  RadialChart,
  RefreshButton,
  StatusIndicator,
  SVG
} from "../../../../components";
import { ChartControls, ChartWrapper, DownloadReportButton } from "./styled";

export const ReportChart = ({
  reportData,
  metricsConfig,
  metricTotal,
  lablesInfoConfig,
  loading,
  reportFileName,
  onRefreshChartData,
  isColumnLegend = false,
  showCalculatedTotal = false,
  showStatus = true
}) => {
  const onGenerateReport = () => {
    if (reportFileName) {
      const result = reportUtils.getReportData(reportData, metricsConfig);
      downloadCSV(result, t(reportFileName));
    }
  };

  const downloadCSV = (data, filename) => {
    const statsCsv = csvUtil.createCSVFile(data);
    csvUtil.downloadCSVFile(statsCsv, filename);
  };

  return (
    <ChartWrapper Container={FlexContainers.FlexColumnStart} gap={16}>
      <RadialChart
        data={reportData}
        title={metricTotal ? metricsConfig[metricTotal]?.name : null}
        radius={140}
        strokeWidth={16}
        startAngle={90}
        endAngle={450}
        Container={FlexContainers.FlexColumn}
        metricsConfig={metricsConfig}
        metricTotal={metricTotal}
        isLoading={loading}
        noDataMessage={strCode.NO_DATA}
        isColumnLegend={isColumnLegend}
        showCalculatedTotal={showCalculatedTotal}
        showOriginalValue
      />

      <ChartControls Container={FlexContainers.FlexRowStart} gap={8}>
        {onRefreshChartData ? (
          <>
            {lablesInfoConfig ? (
              <IconButton
                hasHoverCircle
                tooltipComponent={
                  <ChartLabelsInfoTooltip
                    metricsConfig={metricsConfig}
                    lablesInfoConfig={lablesInfoConfig}
                  />
                }
                xShift={-200}>
                <SVG.QuestionMarkIcon />
              </IconButton>
            ) : null}

            <RefreshButton isLoading={loading} handleRefresh={onRefreshChartData} />
          </>
        ) : showStatus ? (
          <StatusIndicator status={{ id: "inactive", title: strCode.DEACTIVATED_INFO }} />
        ) : null}
      </ChartControls>

      {reportData?.length && reportFileName ? (
        <DownloadReportButton secondary onClick={onGenerateReport}>
          <SVG.DownloadIcon /> {t(strCode.DOWNLOAD_REPORT_BTN)}
        </DownloadReportButton>
      ) : null}
    </ChartWrapper>
  );
};

ReportChart.propTypes = {
  reportData: PropTypes.arrayOf(PropTypes.object.isRequired).isRequired,
  metricsConfig: PropTypes.object.isRequired,
  metricTotal: PropTypes.string,
  lablesInfoConfig: PropTypes.object,
  loading: PropTypes.bool.isRequired,
  reportFileName: PropTypes.string,
  onRefreshChartData: PropTypes.func,
  isColumnLegend: PropTypes.bool,
  showCalculatedTotal: PropTypes.bool,
  showStatus: PropTypes.bool
};
